import React, { useEffect, useState } from "react";
import styles from "../EditBase.module.scss";
import { SonicTermData } from "../../../../common/classes/SonicTerm";
import EditGameDetailModal from "./EditGameDetailModal";
import { SonicGameDetailData } from "../../../../common/classes/SonicGameDetail";
import { SonicGameSelectionData } from "../../../../common/classes/SonicGameSelection";

type Props = {
  isManagement?: boolean;
  initialData?: Array<SonicGameDetailData>;
  games?: Array<SonicTermData>;
  isLoading: boolean;
  gameSelectionOptions: Array<SonicGameSelectionData>;
  handleGameDetails: (details: Array<SonicGameDetailData>) => void;
};
const EditGameDetail: React.FC<Props> = ({
  isManagement = false,
  initialData,
  games,
  isLoading,
  gameSelectionOptions,
  handleGameDetails,
}) => {
  const [isChanged, setIsChanged] = useState<boolean>(false);
  const [details, setDetails] = useState<Array<SonicGameDetailData>>(
    initialData?.length ? initialData : []
  );

  // MyGameと合わせる
  useEffect(() => {
    if (!games) return;

    const mygame_ids = games.map((g) => g.id);

    const checked_array = details.filter((d) => mygame_ids.includes(d.game_id));

    if (details.length !== checked_array.length) {
      if (!isChanged) setIsChanged(true);

      setDetails([...checked_array]);
    }
  }, [games]);

  // 上書き、または新規追加
  const handleUpdate = (update: SonicGameDetailData) => {
    if (!isChanged) setIsChanged(true);

    const details_copy = [...details];

    const search = details_copy.findIndex(
      (value) => value.game_id === update.game_id
    );

    if (search !== -1) {
      details_copy.splice(search, 1, update);
      setDetails([...details_copy]);
    } else {
      setDetails([...details, update]);
    }
  };

  // 親コンポーネントに反映
  useEffect(() => {
    if (isChanged) {
      handleGameDetails(details);
    }
  }, [details]);

  // モーダル関連
  const [editGameId, setEditGameId] = useState<string>();

  const setModal = (value?: string) => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = value ? "hidden" : "unset";
    }

    setEditGameId(value);
  };

  useEffect(() => {
    return () => {
      const html = document.querySelector("html");
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, []);

  return (
    <>
      <div className={styles["p-edit__form__current-mygame"]}>
        {games && games.length > 0 ? (
          <div
            className={
              isManagement
                ? `${styles["p-edit__form__current-mygame-list"]} ${styles["isManagement"]}`
                : styles["p-edit__form__current-mygame-list"]
            }
          >
            <p>設定済み</p>
            <ul>
              {games.map((game, i) => (
                <li
                  key={i}
                  className={styles["p-edit__form__current-mygame-list-item"]}
                >
                  <span>{game.name}</span>
                  <button
                    type="button"
                    onClick={() => setModal(game.id)}
                    className={
                      details.filter((d) => d.game_id === game.id)[0]
                        ? `${styles["detail-btn"]} ${styles["edited"]}`
                        : styles["detail-btn"]
                    }
                  >
                    実績
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className={styles["p-edit__form__current-mygame-list--none"]}>
            {"まだゲームが設定されていないようです。"}
          </div>
        )}
      </div>

      {editGameId ? (
        <EditGameDetailModal
          isLoading={isLoading}
          gameId={editGameId}
          gameTitle={games?.filter((g) => g.id === editGameId)[0].name}
          gameSelection={
            gameSelectionOptions.filter((s) => s.game_id === editGameId)[0]
          }
          initialValue={details?.filter((d) => d.game_id === editGameId)[0]}
          handleUpdate={(update: SonicGameDetailData) => {
            handleUpdate(update);
            setModal(undefined);
          }}
          handleClose={() => setModal(undefined)}
        />
      ) : null}
    </>
  );
};

export default EditGameDetail;
